var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#05944F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3476 20.7L20.2968 14.4H15.36L13.2972 19.8C13.2336 19.992 13.2 20.1912 13.2 20.4C13.2 21.7248 14.58 22.8 16.2852 22.8C17.8572 22.8 19.1568 21.8832 19.3476 20.7ZM24 22.8C25.704 22.8 27.0852 21.7248 27.0852 20.4C27.0852 20.3508 27.0816 20.3016 27.0792 20.2548L26.4684 14.4H21.5316L20.9196 20.25C20.9172 20.2992 20.9148 20.3484 20.9148 20.4C20.9148 21.7248 22.296 22.8 24 22.8ZM30 24.0552V28.8H18V24.0624C17.4744 24.252 16.896 24.36 16.2852 24.36C16.0512 24.36 15.8244 24.3324 15.6 24.3012V31.92C15.6 32.844 16.3548 33.6 17.2776 33.6H30.72C31.644 33.6 32.4 32.8428 32.4 31.92V24.3024C32.1732 24.3372 31.9443 24.3569 31.7148 24.3612C31.1297 24.3606 30.5492 24.257 30 24.0552ZM34.704 19.8L32.6388 14.4H27.7032L28.6512 20.6904C28.836 21.8784 30.1356 22.8 31.7148 22.8C33.4188 22.8 34.8 21.7248 34.8 20.4C34.8 20.1912 34.7664 19.992 34.704 19.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShops);
export default __webpack_public_path__ + "static/media/shops.158ebf305844579d7183f7a66572ee16.svg";
export { ForwardRef as ReactComponent };